import { Group, StaticCanvas } from 'fabric';
import { walkObjects } from '../../canvas/utils/walk-objects';
import { isPillTextbox } from '../types';
import { initPill } from './init-pill';
import { resizePillToFit } from './resize-pill';
import { wireGroupInlineEdit } from './wire-group-inline-edit';

/** Sets up all pills after loading the canvas. */
export function initAllPills(canvas: StaticCanvas): void {
  walkObjects(canvas, obj => {
    if (isPillTextbox(obj)) {
      initPill(obj);
    }
  });

  for (const obj of canvas.getObjects()) {
    const hasPills = obj instanceof Group && obj.getObjects().some(child => isPillTextbox(child));

    if (hasPills) {
      wireGroupInlineEdit(obj, canvas);
    }
  }
}

/** Resizes all pills to fit their content. */
export function resizeAllPills(canvas: StaticCanvas): void {
  walkObjects(canvas, obj => {
    if (isPillTextbox(obj)) {
      resizePillToFit(obj);
    }
  });
}
